import React from 'react';
import './index.css';
import { render } from 'react-dom';
import posthog from 'posthog-js';
import { App } from './App';
posthog.init('phc_z7MkgTzqWjDFr9BpXavVJNZS5PvGbTYkt7cWRnBWyFXj', {
  api_host: 'https://us.i.posthog.com',
  session_recording: {
    maskAllInputs: false
  },
  enable_recording_console_log: true
});
render(<App data-id="element-247" />, document.getElementById('root'));